import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Avatar,
  Box,
  Container,
  Grid,
  Paper,
  TableSortLabel,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { visuallyHidden } from "@mui/utils";
import { baseUrl } from "../../services/AzureStorage";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import Helper from "../../common/Helper";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardCard from "../home/DashboardCard";

export default function CombineResultsAnthros(props) {
  let navigate = useNavigate();
  const useStyles = makeStyles((theme) => ({
    root: {
      margin: "5px 15px",
      border: "1px solid lightgrey",
      borderRadius: "10px",
      boxShadow: "2px 2px 11px grey inset",
    },
    listItemIcon: {
      minWidth: "38px",
    },
    imageIcon: {
      width: "100%",
      height: "100%",
      cursor: "pointer",
    },
    iconRoot: {
      textAlign: "center",
      width: "100%",
      height: "50px",
    },
    cardStyle: {
      border: "1px solid lightgrey",
      borderRadius: "10px",
      height: "250px",
    },
    headerText: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerText2: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerTextInfo: {
      color: "rgb(29, 66, 138)",
      fontSize: "14px",
    },
    headerBox: {
      background: "#c1d0ed",
      borderRadius: "17px",
    },
    smBlue: {
      marginLeft: "16px",
      width: 26,
      height: 26,
      color: theme.palette.getContrastText("#0c2c75"),
      backgroundColor: "#1e3f7e",
      position: "relative",
      borderRadius: "50%",
    },
    stickyColumn: {
      position: "sticky",
      background: "white",
      left: 0,
      zIndex: 1,
      paddingRight: theme.spacing(1),
    },
    playerNameStyle: {
      fontSize: "12px",
      cursor: "pointer",
      "&:hover": {
        color: "blue",
      },
    },
    cellValue: {
      padding: "4px",
      fontSize: "12px",
    },
  }));

  const classes = useStyles();
  const {
    favPlayersASAData,
    favPlayersASADataselected,
    playerAnthrosAndStrengthAgiltyColumns,
    Showval,
    notes,
    loading,
    bodyFat,
    handDimentions,
    weight,
    heightWithShoes,
    heightWithoutShoes,
    standingReach,
    wingSpanDimentions,
    eventId,
    lengthUnits,
    weightUnits,
    getWeightUnitValue,
    getLengthUnitValue,
    getLengthUnitLabelType,
    getWeightUnitLabelType,
    getHandDimensionsUnitValue,
    getHandDimensionsUnitLabelType,
    dXABodyFat,
    isShowDEXABodyFat,
    selectedTab,
    isWebView,
  } = props;

  const newplayerAnthrosAndStrengthAgiltyColumns =
    playerAnthrosAndStrengthAgiltyColumns
      .filter((val) =>
        [
          "playerName",
          // "position",
          // "collegeOrClub",
          "standingReach",
          "wingSpan",
          //   "heightWithShoes",
          "heightWithOutShoes",
          "bodyWeight",
          "handLength",
          // "bodyFat",
          // "bodyFatDXA",
          "hipAbductionPeakForce",
          "hipAdductionPeakForce",
          "kneeExtensionPeakForce",
          "kneeFlexionPeakForce",
          "anklePlantarFlexionPeakForce",
        ].includes(val.id)
      )
      .filter(
        (val) => !(val.id === "bodyFatDXA" && isShowDEXABodyFat === "false")
      )
      .map((val) => ({ id: val.id, headerName: val.headerName }));

  const [order, setOrder] = React.useState("asc");

  const [orderBy, setOrderBy] = React.useState("playerName");

  const tab1Ref = useRef();

  useEffect(() => {
    if (selectedTab === 0) {
      tab1Ref.current.addEventListener("touchstart", isolateTouch, {
        passive: true,
      });
      tab1Ref.current.addEventListener("touchmove", isolateTouch, {
        passive: true,
      });
      tab1Ref.current.addEventListener("touchend", isolateTouch, {
        passive: true,
      });
    }
    return () => {
      if (tab1Ref.current) {
        tab1Ref.current.removeEventListener("touchstart", isolateTouch, {
          passive: true,
        });
        tab1Ref.current.removeEventListener("touchmove", isolateTouch, {
          passive: true,
        });
        tab1Ref.current.removeEventListener("touchend", isolateTouch, {
          passive: true,
        });
      }
    };
  }, [selectedTab]);

  const isolateTouch = (e) => {
    e.stopPropagation();
  };

  const handleSortRequest = (e, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function getComparator(sortOrder, sortOrderBy) {
    return (a, b) => {
      if (
        [
          "heightWithOutShoes",
          "standingReach",
          "wingSpan",
          "heightWithShoes",
        ].includes(sortOrderBy)
      ) {
        return compareByFeetAndInches(a, b, sortOrder, sortOrderBy);
      } else if (["handLength"].includes(sortOrderBy)) {
        return compareByHandLengthAndWidth(a, b, sortOrder);
      } else if (
        [
          "hipAbductionPeakForce",
          "hipAdductionPeakForce",
          "kneeExtensionPeakForce",
          "kneeFlexionPeakForce",
          "anklePlantarFlexionPeakForce",
        ].includes(sortOrderBy)
      ) {
        return compareByPeakForce(a, b, sortOrder, sortOrderBy);
      } else {
        return compareGeneric(a, b, sortOrder, sortOrderBy);
      }
    };
  }

  function compareByFeetAndInches(a, b, sortOrder, sortOrderBy) {
    const feetA = a[sortOrderBy + "Feet"];
    const feetB = b[sortOrderBy + "Feet"];
    const inchesA = a[sortOrderBy + "Inches"];
    const inchesB = b[sortOrderBy + "Inches"];

    if (feetA === feetB) {
      return sortOrder === "asc" ? inchesA - inchesB : inchesB - inchesA;
    } else {
      return sortOrder === "asc" ? feetA - feetB : feetB - feetA;
    }
  }

  function compareByHandLengthAndWidth(a, b, sortOrder) {
    const handWidthA = a["handWidth"];
    const handWidthB = b["handWidth"];
    const handLengthA = a["handLength"];
    const handLengthB = b["handLength"];

    if (handWidthA === handWidthB) {
      return sortOrder === "asc"
        ? handLengthA - handLengthB
        : handLengthB - handLengthA;
    } else {
      return sortOrder === "asc"
        ? handWidthA - handWidthB
        : handWidthB - handWidthA;
    }
  }

  function compareByPeakForce(a, b, sortOrder, sortOrderBy) {
    const peakForceAL = a[sortOrderBy + "L"];
    const peakForceBL = b[sortOrderBy + "L"];
    const peakForceAR = a[sortOrderBy + "R"];
    const peakForceBR = b[sortOrderBy + "R"];

    if (peakForceAL === peakForceBL) {
      return sortOrder === "asc"
        ? peakForceAR - peakForceBR
        : peakForceBR - peakForceAR;
    } else {
      return sortOrder === "asc"
        ? peakForceAL - peakForceBL
        : peakForceBL - peakForceAL;
    }
  }

  function compareGeneric(a, b, sortOrder, sortOrderBy) {
    const getValue = (obj) => {
      const value = obj[sortOrderBy];
      if (value === null || value === undefined || value === "") {
        return "";
      }
      //return !isNaN(parseFloat(value)) ? parseFloat(value) : String(value);
      return /^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(String(value).trim())
        ? parseFloat(value)
        : String(value);
    };

    const valueA = getValue(a);
    const valueB = getValue(b);

    if (valueA === valueB) {
      return 0;
    } else {
      if (typeof valueA === "string") {
        return sortOrder === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      } else {
        return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
      }
    }
  }

  const viewPlayerProfile = (playerId, playerName) => {
    if (isWebView) {
      return sendNavigation("PLAYER_DETAILS", { UserName: playerName });
    }

    navigate(`/${eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${playerId}`, {
      state: { from: "CombineResults", tab: 0 },
    });
  };

  const sendNavigation = (screenName, params) => {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({ action: "NAVIGATE", screen: screenName, params })
    );
  };

  //console.log("favPlayersASADataselected", favPlayersASADataselected);
  return (
    <Container maxWidth={false}>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography className={`${classes.headerText} headerTitle`}>
                  Anthropometry
                </Typography>
              </Box>
            </Box>
          </Box>
          <Grid container spacing={2} pt={3}>
            <TableContainer ref={tab1Ref}>
              {favPlayersASAData && favPlayersASAData.length > 0 && (
                <Table>
                  <TableHead>
                    {newplayerAnthrosAndStrengthAgiltyColumns.map((elem, i) => {
                      return (
                        <TableCell
                          className={
                            elem.id === "playerName"
                              ? classes.stickyColumn
                              : classes.na
                          }
                          sx={{
                            padding: "4px",
                            paddingLeft:
                              elem.id === "playerName" ? "25px" : "0px",
                            fontSize: "12px",
                          }}
                          key={i}
                        >
                          <TableSortLabel
                            active={orderBy === elem.id}
                            direction={orderBy === elem.id ? order : "asc"}
                            onClick={(e) => handleSortRequest(e, elem.id)}
                          >
                            {elem.headerName}
                            {orderBy === elem.id ? (
                              <Box component="span" sx={visuallyHidden}>
                                {order === "desc"
                                  ? "sorted descending"
                                  : "sorted ascending"}
                              </Box>
                            ) : null}
                          </TableSortLabel>
                        </TableCell>
                      );
                    })}
                  </TableHead>
                  <TableHead>
                    <TableCell className={classes.stickyColumn}></TableCell>
                    {/* <TableCell></TableCell>
                    <TableCell></TableCell> */}
                    <TableCell sx={{ fontSize: "12px" }}>
                      {getLengthUnitLabelType(lengthUnits)}
                    </TableCell>
                    <TableCell sx={{ fontSize: "12px" }}>
                      {getLengthUnitLabelType(lengthUnits)}
                    </TableCell>
                    <TableCell sx={{ fontSize: "12px" }}>
                      {getLengthUnitLabelType(lengthUnits)}
                    </TableCell>
                    <TableCell sx={{ fontSize: "12px" }}>
                      {getWeightUnitLabelType(weightUnits)}
                    </TableCell>
                    <TableCell sx={{ fontSize: "12px" }}>
                      W {getHandDimensionsUnitLabelType(lengthUnits)} | L
                      {getHandDimensionsUnitLabelType(lengthUnits)}
                    </TableCell>

                    {/* Note: Based on restrictions from the legal team. */}
                    {/* <TableCell>(%)</TableCell>
                    <TableCell
                      style={{
                        display: isShowDEXABodyFat === "true" ? "" : "none",
                      }}
                    >
                      (%)
                    </TableCell> */}

                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableHead>
                  <TableBody>
                    {Showval
                      ? favPlayersASADataselected
                          .slice()
                          .sort(getComparator(order, orderBy))
                          .map((val, index) => {
                            return (
                              <TableRow key={index} className="scrollTable">
                                <TableCell
                                  className={classes.stickyColumn}
                                  sx={{ padding: "5px", fontSize: "12px" }}
                                >
                                  <Box display="flex">
                                    {val.headshotURL &&
                                    val.headshotURL !== "" ? (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        src={
                                          val.headshotURL
                                            ? baseUrl(val.headshotURL)
                                            : ""
                                        }
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            val.playerID,
                                            val.playerName
                                          )
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    ) : (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            val.playerID,
                                            val.playerName
                                          )
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    )}
                                    &nbsp;&nbsp;
                                    <Typography
                                      variant="body2"
                                      className={classes.playerNameStyle}
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(
                                          val.playerID,
                                          val.playerName
                                        )
                                      }
                                    >
                                      {`${val.playerName}  ${
                                        val.trevisoText || ""
                                      }`}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                {/* <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.position ? val.position : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.collegeOrClub
                                      ? val.collegeOrClub
                                      : "-"}
                                  </Box>
                                </TableCell> */}
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getLengthUnitValue(
                                      val.standingReachFeet,
                                      val.standingReachInches
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getLengthUnitValue(
                                      val.wingSpanFeet,
                                      val.wingSpanInches
                                    )}
                                  </Box>
                                </TableCell>
                                {/* Note:Commenting code client requirement */}
                                {/* <TableCell className={classes.cellValue}>
                                  {getLengthUnitValue(
                                    val.heightWithShoesFeet,
                                    val.heightWithShoesInches
                                  )}
                                </TableCell> */}
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getLengthUnitValue(
                                      val.heightWithOutShoesFeet,
                                      val.heightWithOutShoesInches
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getWeightUnitValue(val.bodyWeight)}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getHandDimensionsUnitValue(val.handWidth)}{" "}
                                    |{" "}
                                    {getHandDimensionsUnitValue(val.handLength)}
                                  </Box>
                                </TableCell>
                                {/* Note: Based on restrictions from the legal team. */}
                                {/* <TableCell className={classes.cellValue}>
                                  {val.bodyFat ? val.bodyFat : "-"}
                                </TableCell>
                                <TableCell
                                  style={{
                                    padding: "4px",
                                    display:
                                      isShowDEXABodyFat === "true"
                                        ? ""
                                        : "none",
                                  }}
                                >
                                  {val.bodyFatDXA ? val.bodyFatDXA : "-"}
                                </TableCell> */}

                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.hipAbductionPeakForceL || 0} |{" "}
                                    {val.hipAbductionPeakForceR || 0}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.hipAdductionPeakForceL || 0} |{" "}
                                    {val.hipAdductionPeakForceR || 0}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.kneeExtensionPeakForceL || 0} |{" "}
                                    {val.kneeExtensionPeakForceR || 0}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.kneeFlexionPeakForceL || 0} |{" "}
                                    {val.kneeFlexionPeakForceR || 0}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.anklePlantarFlexionPeakForceL || 0} |{" "}
                                    {val.anklePlantarFlexionPeakForceR || 0}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            );
                          })
                      : favPlayersASAData
                          .slice()
                          .sort(getComparator(order, orderBy))
                          .map((val, index) => {
                            return (
                              <TableRow key={index} className="scrollTable">
                                <TableCell
                                  className={classes.stickyColumn}
                                  sx={{ padding: "4px", fontSize: "12px" }}
                                >
                                  <Box display="flex">
                                    {val.headshotURL &&
                                    val.headshotURL !== "" ? (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        src={
                                          val.headshotURL
                                            ? baseUrl(val.headshotURL)
                                            : ""
                                        }
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            val.playerID,
                                            val.playerName
                                          )
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    ) : (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            val.playerID,
                                            val.playerName
                                          )
                                        }
                                      >
                                        <Typography
                                          variant="caption"
                                          sx={{ fontSize: "12px" }}
                                        >
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    )}
                                    &nbsp;&nbsp;
                                    <Typography
                                      variant="body2"
                                      className={classes.playerNameStyle}
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(
                                          val.playerID,
                                          val.playerName
                                        )
                                      }
                                    >
                                      {`${val.playerName}  ${
                                        val.trevisoText || ""
                                      }`}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                {/* <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.position ? val.position : "-"}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.collegeOrClub
                                      ? val.collegeOrClub
                                      : "-"}
                                  </Box>
                                </TableCell> */}
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getLengthUnitValue(
                                      val.standingReachFeet,
                                      val.standingReachInches
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getLengthUnitValue(
                                      val.wingSpanFeet,
                                      val.wingSpanInches
                                    )}
                                  </Box>
                                </TableCell>
                                {/* Note:Commenting code client requirement */}
                                {/* <TableCell className={classes.cellValue}>
                                  {getLengthUnitValue(
                                    val.heightWithShoesFeet,
                                    val.heightWithShoesInches
                                  )}
                                </TableCell> */}
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getLengthUnitValue(
                                      val.heightWithOutShoesFeet,
                                      val.heightWithOutShoesInches
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getWeightUnitValue(val.bodyWeight)}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {getHandDimensionsUnitValue(val.handWidth)}{" "}
                                    |{" "}
                                    {getHandDimensionsUnitValue(val.handLength)}
                                  </Box>
                                </TableCell>

                                {/* Note: Based on restrictions from the legal team. */}
                                {/* <TableCell className={classes.cellValue}>
                                  {val.bodyFat ? val.bodyFat : "-"}
                                </TableCell>
                                <TableCell
                                  style={{
                                    padding: "4px",
                                    display:
                                      isShowDEXABodyFat === "true"
                                        ? ""
                                        : "none",
                                  }}
                                >
                                  {val.bodyFatDXA ? val.bodyFatDXA : "-"}
                                </TableCell> */}

                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.hipAbductionPeakForceL || 0} |{" "}
                                    {val.hipAbductionPeakForceR || 0}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.hipAdductionPeakForceL || 0} |{" "}
                                    {val.hipAdductionPeakForceR || 0}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.kneeExtensionPeakForceL || 0} |{" "}
                                    {val.kneeExtensionPeakForceR || 0}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.kneeFlexionPeakForceL || 0} |{" "}
                                    {val.kneeFlexionPeakForceR || 0}
                                  </Box>
                                </TableCell>
                                <TableCell className={classes.cellValue}>
                                  <Box display="flex">
                                    {val.anklePlantarFlexionPeakForceL || 0} |{" "}
                                    {val.anklePlantarFlexionPeakForceR || 0}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </Grid>
        </Paper>
      </Box>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Anthropometry Leader Boards
              </Typography>
            </Box>
            <Box display="flex" pl={2}>
              {notes &&
                notes.length > 0 &&
                notes.find(
                  (x) =>
                    x.childName.replace(/\s/g, "").toLowerCase() ===
                    "Anthropometrics".toLocaleLowerCase()
                ).isActive && (
                  <>
                    <Typography className={classes.headerTextInfo}>
                      {
                        notes.find(
                          (x) =>
                            x.childName.replace(/\s/g, "").toLowerCase() ===
                            "Anthropometrics".toLocaleLowerCase()
                        ).description
                      }
                    </Typography>
                  </>
                )}
            </Box>
          </Box>

          {loading && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </Box>
          )}

          <Grid container spacing={2} pt={2}>
            <DashboardCard
              title="Standing Reach"
              data={standingReach}
              unit={getLengthUnitLabelType(lengthUnits)}
              value="106"
              from="CombineResults"
              tab={0}
              eventId={eventId}
              getLengthUnitValue={getLengthUnitValue}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Wingspan Dimensions"
              data={wingSpanDimentions}
              unit={getLengthUnitLabelType(lengthUnits)}
              value="107"
              from="CombineResults"
              tab={0}
              eventId={eventId}
              getLengthUnitValue={getLengthUnitValue}
              isWebView={isWebView}
            />

            {/* Note:Commenting code client requirement */}
            {/* <DashboardCard
              title="Height With Shoes"
              unit={getLengthUnitLabelType(lengthUnits)}
              data={heightWithShoes}
              value="104"
              from="CombineResults"
              tab={0}
              eventId={eventId}
              getLengthUnitValue={getLengthUnitValue}
              isWebView={isWebView}
            /> */}

            <DashboardCard
              title="Height W/o Shoes"
              data={heightWithoutShoes}
              unit={getLengthUnitLabelType(lengthUnits)}
              value="105"
              from="CombineResults"
              tab={0}
              eventId={eventId}
              getLengthUnitValue={getLengthUnitValue}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Weight"
              unit={getWeightUnitLabelType(weightUnits)}
              data={weight}
              value="103"
              from="CombineResults"
              tab={0}
              eventId={eventId}
              getWeightUnitValue={getWeightUnitValue}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Hand Dimensions"
              data={handDimentions}
              unit={`W ${getHandDimensionsUnitLabelType(
                lengthUnits
              )} | L ${getHandDimensionsUnitLabelType(lengthUnits)}`}
              value="102"
              from="CombineResults"
              tab={0}
              eventId={eventId}
              getHandDimensionsUnitValue={getHandDimensionsUnitValue}
              isWebView={isWebView}
            />

            {/* Note: Based on restrictions from the legal team. */}
            {/* <DashboardCard
              title="Body Fat"
              unit="(%)"
              data={bodyFat}
              value="101"
              from="CombineResults"
              tab={0}
              eventId={eventId}
              isWebView={isWebView}
            />

            {isShowDEXABodyFat === "true" && (
              <DashboardCard
                title="DEXA Body Fat"
                unit="(%)"
                data={dXABodyFat}
                value="108"
                from="HomeContainer"
                eventId={eventId}
                isWebView={isWebView}
              />
            )} */}
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
}
